import {
  Button,
  Card,
  ListItem,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TablePagination,
  useTheme,
  TableSortLabel,
  IconButton,
  makeStyles,
  lighten,
  Paper,
  TextField,
  withStyles,
} from "@material-ui/core";
import React, { useContext, useEffect, useState, useMemo } from "react";
import OwnerHeader from "../Components/OwnerHeader";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { useParams } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import { Instance } from "../../../Config";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";

import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import GlobalContext from "../../../Context/globalContext";
import { SHOW_SNACKBAR } from "../../../Context/globalActions.types";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },

  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover": {
      backgroundColor: "#F3F3F3",
      transform: "scale(1.0019)",
    },
  },
}))(TableRow);

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function DispatchReport() {
  const classes = useStyles();
  const { globalContext, dispatch } = useContext(GlobalContext);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [status, setStatus] = useState("");
  const [distributorCd, setDistributorCd] = useState("");
  const [partyCd, setPartyCd] = useState("");
  const [salesmanCd, setSalesmanCd] = useState("");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("distributorName");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showFilters, setShowFilters] = useState(false);

  const [totalQty, setTotalQty] = useState(0);
  const [availableSizes, setAvailableSizes] = useState([]);

  const [flattenedData, setFlattenedData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [filterStatus] = useState(["Pending", "Dispatched", "Canceled"]);
  const [salesmanList, setSalesmanList] = useState([]);
  const [distributorList, setDistributorList] = useState([]);
  const [partyList, setPartyList] = useState([]);

  const params = useParams();

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleApplyFilters = () => {
    setPage(0);
    fetchData();
  };

  const handleClearFilters = () => {
    setStatus("");
    setDistributorCd("");
    setPartyCd("");
    setSalesmanCd("");
    setFromDate(null);
    setToDate(null);
    setPage(0);
  };

  const getActiveFiltersCount = () => {
    let count = 0;
    if (status) count++;
    if (distributorCd) count++;
    if (partyCd) count++;
    if (salesmanCd) count++;
    if (fromDate) count++;
    if (toDate) count++;
    return count;
  };

  // Transform hierarchical data to flat data with sizes as individual columns
  const flattenData = (hierarchicalData) => {
    const flattened = [];
    const sizeTotals = {};

    // First pass: collect all sizes and their totals (only if quantity > 0)
    hierarchicalData.forEach((distributor) => {
      distributor.items.forEach((item) => {
        if (item.sizes && typeof item.sizes === "object") {
          Object.entries(item.sizes).forEach(([size, sizeData]) => {
            // Skip if size is empty/null
            if (!size || size === "null" || size === "undefined") return;
            // Handle both object format {quantity, desc1} and plain number format
            const quantity = typeof sizeData === "object"
              ? Number(sizeData.quantity)
              : Number(sizeData);
            if (!isNaN(quantity) && quantity > 0) {
              if (!sizeTotals[size]) {
                sizeTotals[size] = 0;
              }
              sizeTotals[size] += quantity;
            }
          });
        }
      });
    });

    // Filter out sizes with no values and sort in standard order
    // Standard letter sizes come first, then numeric sizes
    const sizeOrder = [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
    ];
    const sortedSizes = Object.keys(sizeTotals)
      .filter((size) => sizeTotals[size] > 0)
      .sort((a, b) => {
        const indexA = sizeOrder.indexOf(a);
        const indexB = sizeOrder.indexOf(b);
        // Both are standard sizes - sort by standard order
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        // Only a is standard - a comes first
        if (indexA !== -1) return -1;
        // Only b is standard - b comes first
        if (indexB !== -1) return 1;
        // Both are numeric - sort numerically
        const numA = parseInt(a, 10);
        const numB = parseInt(b, 10);
        if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
        // Fallback to string comparison
        return a.localeCompare(b);
      });

    setAvailableSizes(sortedSizes);

    // Second pass: create flattened data
    hierarchicalData.forEach((distributor) => {
      distributor.items.forEach((item) => {
        // Extract packing (desc1) from the first available size
        let packing = "";
        let totalPcs = 0;

        if (item.sizes && typeof item.sizes === "object") {
          const sizeEntries = Object.entries(item.sizes);
          if (sizeEntries.length > 0) {
            // Get desc1 from first size entry
            const firstSizeData = sizeEntries[0][1];
            if (typeof firstSizeData === "object" && firstSizeData.desc1) {
              packing = firstSizeData.desc1;
            }

            // Calculate totalPcs = sum of (desc1 * quantity) for each size
            sizeEntries.forEach(([, sizeData]) => {
              if (typeof sizeData === "object") {
                const desc1 = parseFloat(sizeData.desc1) || 0;
                const qty = parseFloat(sizeData.quantity) || 0;
                totalPcs += desc1 * qty;
              }
            });
          }
        }

        // Create a row for each item with individual size properties
        const row = {
          distributorCode: distributor.distributorCode,
          distributorName: distributor.distributorName,
          itemCode: item.itemCode,
          itemName: item.itemName,
          sizes: item.sizes || {},
          totalQuantity: item.totalQuantity || 0,
          packing: packing,
          totalPcs: totalPcs,
        };

        flattened.push(row);
      });
    });

    return flattened;
  };

  const fetchData = () => {
    setIsLoading(true);
    setAvailableSizes([]); // Reset sizes before fetching new data

    const queryParams = new URLSearchParams({
      mobileNo: params.mobileNo,
    });

    if (fromDate)
      queryParams.append("fromDate", moment(fromDate).format("YYYY-MM-DD"));
    if (toDate)
      queryParams.append("toDate", moment(toDate).format("YYYY-MM-DD"));
    if (status) queryParams.append("status", status);
    if (distributorCd) queryParams.append("distributorCd", distributorCd);
    if (partyCd) queryParams.append("partyCd", partyCd);
    if (salesmanCd) queryParams.append("salesmanCd", salesmanCd);

    Instance.get(`/reports/dispatch-report?${queryParams.toString()}`)
      .then((res) => {
        if (res && res.data && res.data.result) {
          setIsLoading(false);
          const flattened = flattenData(res.data.result);
          setFlattenedData(flattened);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: error.response?.data?.message || "Something went wrong",
            type: "error",
          },
        });
      });
  };

  // Fetch filter options
  useEffect(() => {
    // Fetch salesmen
    Instance.get(`/orders/filter-options/salesmen?mobileNo=${params.mobileNo}`)
      .then((res) => {
        if (res && res.data && res.data.result) {
          setSalesmanList(res.data.result || []);
        }
      })
      .catch(() => {});

    // Fetch distributors
    Instance.get(
      `/orders/filter-options/distributors?mobileNo=${params.mobileNo}`
    )
      .then((res) => {
        if (res && res.data && res.data.result) {
          setDistributorList(res.data.result || []);
        }
      })
      .catch(() => {});

    // Fetch parties
    Instance.get(`/reports/filters/orders?mobileNo=${params.mobileNo}`)
      .then((res) => {
        if (res && res.data && res.data.result) {
          setPartyList(
            res.data.result.map((e) => {
              return {
                ACC_CD: e.accounts.ACC_CD,
                ACC_NAME: e.accounts.ACC_NAME,
              };
            })
          );
        }
      })
      .catch(() => {});
  }, [params.mobileNo]);

  // Prepare CSV headers
  const getCsvHeaders = () => {
    return [
      { label: "Distributor Name", key: "distributorName" },
      { label: "Item Code", key: "itemCode" },
      { label: "Item Name", key: "itemName" },
      { label: "Packing", key: "packing" },
      ...availableSizes.map((size) => ({ label: size, key: size })),
      { label: "Total Qty", key: "totalQuantity" },
      { label: "Total PCS", key: "totalPcs" },
    ];
  };

  // Prepare CSV data with size columns flattened
  const getCsvData = () => {
    const rows = flattenedData.map((row) => {
      const sizeColumns = {};
      availableSizes.forEach((size) => {
        const sizeData = row.sizes[size];
        if (typeof sizeData === "object") {
          sizeColumns[size] = sizeData.quantity || "";
        } else {
          sizeColumns[size] = sizeData || "";
        }
      });
      return {
        distributorName: row.distributorName,
        itemCode: row.itemCode,
        itemName: row.itemName,
        packing: row.packing,
        ...sizeColumns,
        totalQuantity: row.totalQuantity,
        totalPcs: row.totalPcs,
      };
    });

    // Calculate totals
    const grandTotalQty = flattenedData.reduce((sum, row) => sum + (row.totalQuantity || 0), 0);
    const grandTotalPcs = flattenedData.reduce((sum, row) => sum + (row.totalPcs || 0), 0);

    // Add totals row
    const totalsRow = {
      distributorName: "",
      itemCode: "",
      itemName: "TOTAL",
      packing: "",
      totalQuantity: grandTotalQty.toFixed(2),
      totalPcs: grandTotalPcs.toFixed(2),
    };
    availableSizes.forEach((size) => {
      totalsRow[size] = "";
    });

    rows.push(totalsRow);
    return rows;
  };

  const exportPdf = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "landscape";

    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const headers = [
      [
        "Distributor",
        "Item Code",
        "Item Name",
        "Packing",
        ...availableSizes,
        "Total Qty",
        "Total PCS",
      ],
    ];

    const data = flattenedData.map((row) => [
      row.distributorName,
      row.itemCode,
      row.itemName,
      row.packing || "",
      ...availableSizes.map((size) => row.sizes[size]?.quantity || row.sizes[size] || ""),
      row.totalQuantity.toFixed(2),
      row.totalPcs.toFixed(2),
    ]);

    // Calculate totals
    const grandTotalQty = flattenedData.reduce((sum, row) => sum + (row.totalQuantity || 0), 0);
    const grandTotalPcs = flattenedData.reduce((sum, row) => sum + (row.totalPcs || 0), 0);

    // Add totals row
    data.push([
      "",
      "",
      "TOTAL",
      "",
      ...availableSizes.map(() => ""),
      grandTotalQty.toFixed(2),
      grandTotalPcs.toFixed(2),
    ]);

    let content = {
      startY: 70,
      head: headers,
      body: data,
      styles: { fontSize: 7 },
    };

    let width1 = doc.internal.pageSize.getWidth();

    doc.setFontSize(14).setFont(undefined, "bold");
    doc
      .text(globalContext.company[0].COMP_NAME, width1 / 2, 20, {
        align: "center",
      })
      .setFontSize(8)
      .setFont(undefined, "bold");
    doc.text(globalContext.company[0].ADDRS, width1 / 2, 38, {
      align: "center",
    });
    if (fromDate || toDate) {
      doc.text(
        `From Date: ${
          fromDate ? moment(fromDate).format("DD-MM-YYYY") : "N/A"
        } To: ${toDate ? moment(toDate).format("DD-MM-YYYY") : "N/A"}`,
        width1 / 2,
        60,
        {
          align: "center",
        }
      );
    }
    doc.autoTable(content);
    doc.save("DispatchReport.pdf");
  };

  // Get current page data
  const currentPageData = useMemo(() => {
    return stableSort(flattenedData, getComparator(order, orderBy))
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [flattenedData, order, orderBy, page, rowsPerPage]);

  // Calculate visible sizes based on current page data only
  const visibleSizes = useMemo(() => {
    const sizeOrder = [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
    ];

    const sizesWithValues = new Set();
    currentPageData.forEach((row) => {
      if (row.sizes && typeof row.sizes === "object") {
        Object.entries(row.sizes).forEach(([size, sizeData]) => {
          // Handle both object format {quantity, desc1} and plain number format
          const quantity = typeof sizeData === "object"
            ? Number(sizeData.quantity)
            : Number(sizeData);
          if (!isNaN(quantity) && quantity > 0) {
            sizesWithValues.add(size);
          }
        });
      }
    });

    return Array.from(sizesWithValues).sort((a, b) => {
      const indexA = sizeOrder.indexOf(a);
      const indexB = sizeOrder.indexOf(b);
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      const numA = parseInt(a, 10);
      const numB = parseInt(b, 10);
      if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
      return a.localeCompare(b);
    });
  }, [currentPageData]);

  const headCells = useMemo(() => [
    {
      id: "distributorName",
      label: "Distributor",
    },
    {
      id: "itemCode",
      label: "Item Code",
    },
    {
      id: "itemName",
      label: "Item Name",
    },
    {
      id: "packing",
      label: "Packing",
    },
    ...visibleSizes.map((size) => ({
      id: `size_${size}`,
      label: size,
    })),
    {
      id: "totalQuantity",
      label: "Total Qty",
    },
    {
      id: "totalPcs",
      label: "Total PCS",
    },
  ], [visibleSizes]);

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;

    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead className="sticky top-0">
        <TableRow className="md:mx-3 md:bg-white bg-gray-200">
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align="left"
              className="font-bold border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-5 w-max bg-transparent"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
      </div>
    );
  }

  useEffect(() => {
    if (flattenedData) {
      const total = flattenedData.reduce((accumulator, object) => {
        return accumulator + (object.totalQuantity || 0);
      }, 0);
      setTotalQty(total);
    }
  }, [flattenedData]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <OwnerHeader>
      <div className="md:flex items-center justify-between px-3 md:px-4 py-3">
        <div>
          <div className="text-indigo-500 font-semibold text-sm md:text-base">
            Reporting
          </div>
          <div className="text-xl md:text-2xl font-extrabold leading-7 sm:leading-10 truncate mt-1">
            Dispatch Report
          </div>
        </div>
      </div>
      <div className="py-1 min-h-screen bg-[#F1F5F9] px-2">
        {/* Filter Section */}
        <Card className="mb-4 shadow-sm">
          <ListItem className="pb-0">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center">
                <FilterListIcon className="text-indigo-500" />
                <Typography
                  variant="h6"
                  className="text-indigo-500 uppercase font-bold tracking-wider text-xs ml-2"
                >
                  Advanced Filters
                </Typography>
              </div>
              <Button
                size="small"
                onClick={() => setShowFilters(!showFilters)}
                className="text-indigo-500"
              >
                {showFilters ? "Hide" : "Show"}
              </Button>
            </div>
          </ListItem>
          {showFilters && (
            <>
              <ListItem className="pt-0 pb-2">
                <Typography
                  variant="h6"
                  className="text-gray-500 uppercase font-bold tracking-wider text-[9px]"
                >
                  Filter dispatch report by salesman, distributor, party, or
                  date range
                </Typography>
              </ListItem>
              <div className="px-4 pb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
                  {/* Salesman Filter */}
                  <Autocomplete
                    id="salesman-filter"
                    options={salesmanList}
                    getOptionLabel={(option) => option.SMAN_NAME || ""}
                    value={
                      salesmanList.find((s) => s.SMAN_CD === salesmanCd) || null
                    }
                    onChange={(_, newValue) => {
                      setSalesmanCd(newValue ? newValue.SMAN_CD : "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Salesman"
                        variant="outlined"
                        size="small"
                        placeholder="Select Salesman"
                      />
                    )}
                    className="bg-white"
                  />

                  {/* Distributor Filter */}
                  <Autocomplete
                    id="distributor-filter"
                    options={distributorList}
                    getOptionLabel={(option) => option.ACC_NAME || ""}
                    value={
                      distributorList.find((d) => d.ACC_CD === distributorCd) ||
                      null
                    }
                    onChange={(_, newValue) => {
                      setDistributorCd(newValue ? newValue.ACC_CD : "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Distributor"
                        variant="outlined"
                        size="small"
                        placeholder="Select Distributor"
                      />
                    )}
                    className="bg-white"
                  />

                  {/* Party Filter */}
                  <Autocomplete
                    id="party-filter"
                    options={partyList}
                    getOptionLabel={(option) => option.ACC_NAME || ""}
                    value={partyList.find((p) => p.ACC_CD === partyCd) || null}
                    onChange={(_, newValue) => {
                      setPartyCd(newValue ? newValue.ACC_CD : "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Party"
                        variant="outlined"
                        size="small"
                        placeholder="Select Party"
                      />
                    )}
                    className="bg-white"
                  />

                  {/* Status Filter */}
                  <Autocomplete
                    id="status-filter"
                    options={filterStatus}
                    getOptionLabel={(option) => option}
                    value={status || null}
                    onChange={(_, newValue) => {
                      setStatus(newValue || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Status"
                        variant="outlined"
                        size="small"
                        placeholder="Select Status"
                      />
                    )}
                    className="bg-white"
                  />

                  {/* From Date */}
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    inputVariant="outlined"
                    format="DD/MM/yyyy"
                    size="small"
                    label="From Date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change from date",
                    }}
                    className="bg-white"
                    clearable
                  />

                  {/* To Date */}
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    inputVariant="outlined"
                    format="DD/MM/yyyy"
                    size="small"
                    label="To Date"
                    value={toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change to date",
                    }}
                    className="bg-white"
                    clearable
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2">
                  <Button
                    variant="contained"
                    disableElevation
                    className="bg-[#3333cc] text-white"
                    onClick={handleApplyFilters}
                  >
                    Apply Filters
                  </Button>
                  <Button
                    variant="outlined"
                    className="border-[#3333cc] text-[#3333cc]"
                    onClick={handleClearFilters}
                    startIcon={<ClearIcon />}
                    disabled={getActiveFiltersCount() === 0}
                  >
                    Clear Filters
                  </Button>
                </div>
              </div>
            </>
          )}
        </Card>

        <React.Fragment>
          <TableContainer
            style={{
              overflowX: "clip",
            }}
            component={Paper}
          >
            <div className="md:flex justify-between w-full my-3 px-2 pt-3">
              <Typography className="md:ml-2 text-md md:text-lg mb-2 font-medium">
                Dispatch Report
              </Typography>
              <div>
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc] mt-2 md:mt-0"
                  startIcon={<SaveAltIcon />}
                >
                  <CSVLink
                    data={getCsvData()}
                    headers={getCsvHeaders()}
                    filename="DispatchReport.csv"
                    className="text-blue-600"
                  >
                    Excel
                  </CSVLink>
                </Button>
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc] mt-2 md:mt-0 ml-2"
                  startIcon={<InsertDriveFileOutlinedIcon />}
                  onClick={() => {
                    exportPdf();
                  }}
                >
                  PDF
                </Button>
              </div>
            </div>
            <div className="max-h-screen overflow-x-hidden">
              <Table stickyHeader>
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={flattenedData ? flattenedData.length : null}
                />
                <TableBody>
                  {isLoading && flattenedData.length === 0 ? (
                    <StyledTableRow>
                      {headCells.map((_cell, index) => (
                        <StyledTableCell
                          key={index}
                          className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                        >
                          <Skeleton />
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  ) : !isLoading && flattenedData.length === 0 ? (
                    <TableRow hover tabIndex={-1}>
                      <TableCell align="center" colSpan={headCells.length}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  ) : (
                    currentPageData.map((row, index) => {
                        return (
                          <StyledTableRow
                            key={`${row.distributorCode}-${row.itemCode}-${index}`}
                            className="hover:font-semibold"
                          >
                            <StyledTableCell
                              align="left"
                              style={{
                                fontWeight: "inherit",
                              }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.distributorName}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{
                                fontWeight: "inherit",
                              }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.itemCode}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{
                                fontWeight: "inherit",
                              }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.itemName}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{
                                fontWeight: "inherit",
                              }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.packing || ""}
                            </StyledTableCell>
                            {visibleSizes.map((size) => (
                              <StyledTableCell
                                key={size}
                                align="left"
                                style={{
                                  fontWeight: "inherit",
                                }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {row.sizes[size]?.quantity || row.sizes[size] || ""}
                              </StyledTableCell>
                            ))}
                            <StyledTableCell
                              align="left"
                              style={{
                                fontWeight: "inherit",
                              }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4 font-bold"
                            >
                              {parseFloat(row.totalQuantity).toFixed(2)}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{
                                fontWeight: "inherit",
                              }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4 font-bold"
                            >
                              {parseFloat(row.totalPcs).toFixed(2)}
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })
                  )}
                </TableBody>
              </Table>
            </div>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={flattenedData ? flattenedData.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
            {flattenedData && flattenedData.length > 0 && (
              <div className="px-4 py-3 bg-gray-50 border-t border-gray-200">
                <div className="text-sm font-semibold text-gray-700">
                  Total Quantity:{" "}
                  <span className="text-blue-600">
                    {parseFloat(totalQty).toFixed(2)}
                  </span>
                </div>
              </div>
            )}
          </TableContainer>
        </React.Fragment>
      </div>
    </OwnerHeader>
  );
}
